// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"LoginRequiredDialog_buttonContainer__JpPMi","content":"LoginRequiredDialog_content__BeWJO","icon":"LoginRequiredDialog_icon__QyHeM"};